/**
=========================================================
* Soft UI Dashboard PRO React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

const defaultLineChartData = {
  labels: ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  datasets: [
    {
      label: "Positive",
      color: "info",
      data: [50, 40, 300, 200, 250, 260, 290, 230, 400],
    },
    {
      label: "Negative",
      color: "warning",
      data: [30, 90, 40, 140, 260, 290, 300, 150, 180],
    },
  ],
};

export default defaultLineChartData;
